import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCertifiedOutline from '@adv-mt/mt-svg-icons/lib/CertifiedOutline.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import IconHandShakeOutline from '@adv-mt/mt-svg-icons/lib/HandShakeOutline.js'
import IconLockOutline from '@adv-mt/mt-svg-icons/lib/LockOutline.js'
import IconShieldUserOutline from '@adv-mt/mt-svg-icons/lib/ShieldUserOutline.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const SellerCheckDocumentsTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/tramites-y-servicios.svg`

  const {page} = useAnalyticsTrack()

  const config = domain.get('config')
  const pageName = config.get('page').TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DOCUMENTS_PAGE_NAME

  useMount(async () => {
    const getTrackingData = async () => {
      return domain.get('get_page_tracking_data_use_case').execute({
        page: pageName
      })
    }

    const pageTrackingData = await getTrackingData()

    page(pageTrackingData)
  })

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionSellerCheckDocumentsModal-modalContainer">
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionSellerCheckDocumentsModal-modalChildren">
                  <div className="mt-TransactionSellerCheckDocumentsModal-description">
                    {htmlStringToReactElement(
                      i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.MAIN_TEXT', {
                        highlightStart: '<strong>',
                        highlightEnd: '</strong>'
                      })
                    )}
                  </div>
                  <div className="mt-TransactionSellerCheckDocumentsModal-contentWrapper mt-TransactionSellerCheckDocumentsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentIcon">
                      <IconHandShakeOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentText">
                      <div className="mt-TransactionSellerCheckDocumentsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.CONTRACT.TITLE')}
                      </div>
                      <span>{i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.CONTRACT.DESCRIPTION')}</span>
                    </div>
                  </div>
                  <div className="mt-TransactionSellerCheckDocumentsModal-contentWrapper mt-TransactionSellerCheckDocumentsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentIcon">
                      <IconLockOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentText">
                      <div className="mt-TransactionSellerCheckDocumentsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.DEPOSIT_CONTRACT.TITLE')}
                      </div>
                      <span>
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.DEPOSIT_CONTRACT.DESCRIPTION')}
                      </span>
                    </div>
                  </div>
                  <div className="mt-TransactionSellerCheckDocumentsModal-contentWrapper mt-TransactionSellerCheckDocumentsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentIcon">
                      <IconShieldUserOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentText">
                      <div className="mt-TransactionSellerCheckDocumentsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AGENT_MANDATE.TITLE')}
                      </div>
                      <span>{i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AGENT_MANDATE.DESCRIPTION')}</span>
                    </div>
                  </div>
                  <div className="mt-TransactionSellerCheckDocumentsModal-contentWrapper mt-TransactionSellerCheckDocumentsModal-contentWrapper--withIcon">
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentIcon">
                      <IconCertifiedOutline size={ATOM_ICON_SIZES.medium} />
                    </div>
                    <div className="mt-TransactionSellerCheckDocumentsModal-contentText">
                      <div className="mt-TransactionSellerCheckDocumentsModal-contentTextTitle">
                        {i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AFFIDAVIT.TITLE')}
                      </div>
                      <span>{i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.DOCUMENTS.AFFIDAVIT.DESCRIPTION')}</span>
                    </div>
                  </div>
                </div>
              ),
              headerImage: (
                <div className="mt-TransactionModal-contentHeaderImageWrapper">
                  <AtomImage
                    alt={i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.TITLE.SELLER')}
                    className="mt-TransactionModal-contentHeaderImage"
                    src={imageUrl}
                  />
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.CHECK_DOCUMENTS.TITLE.SELLER'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
